
























/* eslint-disable */
import getUrlParam from '@/common/utils/getUrlParam';
import UserAgreementModal from "./components/edit/UserAgreement.vue";
import Activity from './components/enroll/Activity.vue'


import { Component, Vue, Mixins } from "vue-property-decorator";
import PageInitialMixin from "@/mixins/PageInitialMixin";
import { Getter, Action } from "vuex-class";

import FooterLayer from "@/layers/FooterLayer.vue";
import EditFooter from "@/components/common/edit/EditFooterAIEnroll.vue";
import UserAgreementContentModal from "./components/edit/UserAgreementContentModal.vue";
import CheckFooter from '@/components/common/index/CheckFooter.vue';

// Mask层级
import MaskLayer from "@/layers/MaskLayer.vue";

@Component({
  components: {
    "activity": Activity,
    "footer-layer": FooterLayer,
    "edit-footer": EditFooter,
    "mask-layer": MaskLayer,
    "user-agreement-modal": UserAgreementModal,
    "user-agreement-content-modal": UserAgreementContentModal,
    "check-footer": CheckFooter,
  },
})
export default class poseType extends Mixins(PageInitialMixin) {

  @Getter("contactQrcode") contactQrcode!: string;
  @Getter("title") title!: string;
  @Getter("instName") instName!: string;
  @Getter("deadline") deadline!: string;
  @Getter("activityRule") activityRule!: string;
  @Getter("instAddress") instAddress!: string;
  @Getter("instPhone") instPhone!: string;
  @Getter("institutionIntros") institutionIntros!: Array<object>;
  @Action("changeShowFooter") changeShowFooter!: Function;
  isCopy: boolean = false;
  isFromDistribute: boolean = true;
  message: object = {};
  created() {
    const isCopy = getUrlParam('state') == 'copy';
    this.isCopy = isCopy;
  }
  mounted() {
    // window.addEventListener("touchmove", this.hiddenKeyboard);
    if(getUrlParam('type')=='share'||getUrlParam('type')=='check') {
      this.changeShowFooter(false);
    }
  }
  hiddenKeyboard(evt: Event): void {
    (document.activeElement as HTMLElement).blur();
  }
}
